import { __assign, __awaiter, __extends, __generator } from "tslib";
import * as React from 'react';
import * as moment from 'moment-timezone';
import { withTranslation } from 'react-i18next';
import { Text, TextButton, Button } from 'wix-ui-tpa';
import { CalendarCellAlignment, CalendarCellTimes, } from 'wix-ui-tpa/dist/src/components/CalendarCell/types';
import { ButtonSize, ButtonPriority, } from 'wix-ui-tpa/dist/src/components/Button/types';
import { TextTypography } from 'wix-ui-tpa/dist/src/components/Text/types';
import Calendar from '../Calendar/Calendar';
import AgendaCell from '../../presentationals/AgendaCell/AgendaCell';
import * as utils from '../Calendar/CalendarUtlis/CalendarUtils';
import TimeFormatsEnum from '../../../enums/TimeFormatsEnum';
import MomentEnum from '../../../enums/MomentEnum';
import { st, classes } from './AgendaCalendar.st.css';
import Actions from '../../../enums/ActionsEnum';
import WeekStarters from '../../../enums/WeekStartersEnum';
import { Preloader } from '@wix/wix-base-ui';
import WixStylesContext from '../../../context/wixStylesContext';
import CalendarPropsContext from '../../../context/calendarPropsContext';
import getWixStylesContextData from '../../../context/getWixStylesContextData';
import getCalendarPropsData from '../../../context/getCalendarPropsData';
var AgendaCalendar = /** @class */ (function (_super) {
    __extends(AgendaCalendar, _super);
    function AgendaCalendar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eventRef = React.createRef();
        _this.state = {
            toggleEventRender: false,
            isReachedLastEvent: false,
            isShrinking: true,
            isPastShown: false,
            isShowAll: false,
            cuttedEventIndex: Infinity,
            windowHeight: window.innerHeight,
            cuttedDate: '',
            lastDateShown: '',
            action: Actions.NO_ACTION,
            isMounted: false,
        };
        _this.hasCuttedDate = false; // flag keeping the cutted date from mutate by the cell cut handler. usally event cut handler will set the cutted date,  sometime there is no event cut, e.g when the events don't reach the bottom of the page. in this case we use the cellRef to keep track of the current last cell and event shown. that way on resizing the component can drop/add the right event/cell. so, we need flag that tell the component if there was event cut and if not use the cell cut.
        _this.agendaDaysInserter = function (_a) {
            var localeToggle = _a.localeToggle, hasTodayEvents = _a.hasTodayEvents, hasFutureEvents = _a.hasFutureEvents;
            return function (_a) {
                var events = _a.events, day = _a.day, timeType = _a.timeType, current = _a.current;
                var _b = _this.state, isPastShown = _b.isPastShown, toggleEventRender = _b.toggleEventRender;
                if ((current && !hasTodayEvents && !hasFutureEvents && !isPastShown) ||
                    (!events.length && timeType !== CalendarCellTimes.today) ||
                    (events.length &&
                        current &&
                        timeType === CalendarCellTimes.pastDate &&
                        !isPastShown) ||
                    (isPastShown &&
                        !events.length &&
                        timeType === CalendarCellTimes.today &&
                        !hasFutureEvents)) {
                    return;
                }
                var _c = _this.props, timezone = _c.timezone, timeFormat = _c.timeFormat, isFixedSize = _c.isFixedSize, isMobile = _c.isMobile, openPopup = _c.openPopup, onEventExpanded = _c.onEventExpanded, onCopyClick = _c.onCopyClick, onAttachmentClick = _c.onAttachmentClick, onLocationClick = _c.onLocationClick, weekStarter = _c.weekStarter, experiments = _c.experiments, isStretchable = _c.isStretchable, privetEventsTitle = _c.privetEventsTitle, locale = _c.locale;
                var _d = _this.state, cuttedDate = _d.cuttedDate, cuttedEventIndex = _d.cuttedEventIndex, isShowAll = _d.isShowAll;
                var isCuttedDate = moment(day).isSame(cuttedDate, MomentEnum.daysString);
                var isHidden = moment(day).isAfter(cuttedDate, MomentEnum.daysString);
                var cuttedEventIndexToProp = Infinity;
                if (isFixedSize && !isShowAll) {
                    if (isCuttedDate) {
                        cuttedEventIndexToProp = cuttedEventIndex;
                    }
                    else if (isHidden) {
                        cuttedEventIndexToProp = 0;
                    }
                }
                return (React.createElement(AgendaCell, { key: day, events: events, isMobile: isMobile, localeToggle: localeToggle, timeType: timeType, day: day, timeFormat: timeFormat, className: classes.AgendaCellExtension, isHidden: isHidden, handleCut: isFixedSize && !isShowAll ? _this.cellCutHandler : function () { }, handleEventCut: isFixedSize && !isShowAll ? _this.eventCutHandler : function () { }, cuttedEventIndex: cuttedEventIndexToProp, cuttedDate: cuttedDate, isPastShown: isPastShown, toggleEventRender: toggleEventRender, openPopup: openPopup, onEventExpanded: onEventExpanded, 
                    //@ts-ignore
                    onCopyClick: onCopyClick, 
                    //@ts-ignore
                    onLocationClick: onLocationClick, 
                    //@ts-ignore
                    onAttachmentClick: onAttachmentClick, weekStarter: weekStarter, timezone: timezone, experiments: experiments, isStretchable: isStretchable, privetEventsTitle: privetEventsTitle, locale: locale }));
            };
        };
        _this.cellCutHandler = function (date, cellRef) {
            if (!cellRef.current) {
                return;
            }
            var dates = _this.props.dates;
            var cellRect = cellRef.current.getBoundingClientRect();
            var windowBottom = _this.getWindowBottom();
            if (!_this.hasCuttedDate &&
                cellRect.bottom >= windowBottom &&
                cellRect.top <= windowBottom) {
                var cuttedDateToSet = moment(date)
                    .subtract(1, MomentEnum.days)
                    .format(MomentEnum.yearMonthDay);
                _this.setState({ cuttedDate: cuttedDateToSet });
            }
            else if (!_this.hasCuttedDate &&
                utils.isLastDateWithEvents({ date: date, dates: dates })) {
                var cuttedEventIndex = utils.getDateEventsAmount({ date: date, dates: dates });
                _this.setState({ lastDateShown: date, cuttedEventIndex: cuttedEventIndex });
            }
        };
        //getWindowBottom = () => window.innerHeight - 20 - 80; // 20: padding-bottom, 80: header-height
        _this.getWindowBottom = function () {
            return window.innerHeight > 500 ? window.innerHeight - 20 - 80 : 500 - 20 - 80;
        }; // 20: padding-bottom, 80: header-height
        _this.eventCutHandler = function (eventIndex, eventRef, startDate, isResizing) {
            if (!eventRef.current) {
                return;
            }
            var dates = _this.props.dates;
            var _a = _this.state, isShrinking = _a.isShrinking, lastDateShown = _a.lastDateShown;
            var eventRect = eventRef.current.getBoundingClientRect();
            var windowBottom = _this.getWindowBottom();
            _this.eventRef = eventRef;
            if (isShrinking &&
                eventRect.bottom >= windowBottom &&
                eventRect.top <= windowBottom) {
                _this.hasCuttedDate = true;
                var cuttedDateToSet = startDate || lastDateShown;
                var cuttedEventIndex = eventIndex === Infinity
                    ? utils.getDateEventsAmount({ date: cuttedDateToSet, dates: dates })
                    : eventIndex;
                if (eventIndex <= 0) {
                    cuttedDateToSet = utils.getPrevDateWithEvents({
                        date: cuttedDateToSet,
                        dates: dates,
                    });
                    cuttedEventIndex = utils.getDateEventsAmount({
                        date: cuttedDateToSet,
                        dates: dates,
                    });
                }
                _this.setState({
                    cuttedEventIndex: cuttedEventIndex,
                    cuttedDate: cuttedDateToSet,
                    isReachedLastEvent: false,
                });
            }
            else if (isResizing &&
                isShrinking &&
                eventRect.bottom > windowBottom &&
                eventRect.top >= windowBottom) {
                _this.hasCuttedDate = false;
                _this.reRenderEvent();
            }
        };
        _this.reRenderEvent = function () {
            _this.setState(function (prev) { return ({ toggleEventRender: !prev.toggleEventRender }); });
        };
        _this.eventAddtionHandler = function (eventIndex, eventRef, cuttedDate) {
            if (!eventRef.current) {
                return;
            }
            var dates = _this.props.dates;
            var _a = _this.state, isShrinking = _a.isShrinking, lastDateShown = _a.lastDateShown;
            var eventRect = eventRef.current.getBoundingClientRect();
            var windowHeight = _this.getWindowBottom();
            var afterResizingHeight = eventRect.bottom + eventRect.height;
            var cuttedEventIndex = eventIndex;
            var cuttedDateToSet = cuttedDate || lastDateShown;
            var newCuttedDate = moment(cuttedDateToSet).format(MomentEnum.yearMonthDay);
            var isReachedLastEvent = false;
            while (!isShrinking && afterResizingHeight < windowHeight) {
                var cuttedDateEventsAmount = utils.getDateEventsAmount({
                    date: newCuttedDate,
                    dates: dates,
                });
                if (cuttedDateToSet === lastDateShown &&
                    cuttedDateEventsAmount <= eventIndex) {
                    cuttedEventIndex = cuttedDateEventsAmount;
                    isReachedLastEvent = true;
                }
                else if (cuttedDateEventsAmount < eventIndex) {
                    var nextDateWithEvents = utils.getNextDateWithEvents({
                        date: newCuttedDate,
                        dates: dates,
                    });
                    cuttedEventIndex = 1;
                    isReachedLastEvent =
                        !nextDateWithEvents ||
                            (utils.isLastDateWithEvents({ date: nextDateWithEvents, dates: dates }) &&
                                //@ts-ignore
                                dates[nextDateWithEvents].length === cuttedEventIndex);
                    newCuttedDate = nextDateWithEvents || newCuttedDate;
                }
                afterResizingHeight += eventRect.height;
            }
            _this.setState({
                cuttedEventIndex: cuttedEventIndex,
                cuttedDate: newCuttedDate,
                isReachedLastEvent: isReachedLastEvent,
            });
        };
        _this.showPastEvents = function () {
            var _a = _this.props, onShowPastEventsClick = _a.onShowPastEventsClick, handleShowMore = _a.handleShowMore;
            _this.setState({
                isPastShown: true,
                isShowAll: true,
                cuttedEventIndex: Infinity,
                cuttedDate: '',
            }, function () {
                onShowPastEventsClick &&
                    onShowPastEventsClick() &&
                    handleShowMore &&
                    handleShowMore();
            });
        };
        _this._handleMonthChange = function (start, end, timezone, isNextClicked) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.initState();
                        return [4 /*yield*/, this.props.handleMonthChange(start, end, timezone, isNextClicked)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this._onTodayClick = function () {
            _this.initState();
            //@ts-ignore
            _this.props.onTodayClick();
        };
        _this.initState = function () {
            _this.hasCuttedDate = false;
            _this.setState(function (prev) { return ({
                isShrinking: true,
                isPastShown: false,
                isShowAll: false,
                cuttedEventIndex: Infinity,
                cuttedDate: '',
                lastDateShown: '',
                isReachedLastEvent: false,
                toggleEventRender: !prev.toggleEventRender,
            }); }, function () { return _this.setState({ isMounted: true }); });
        };
        //FIXME
        _this.showMoreHandler = function () {
            var handleShowMore = _this.props.handleShowMore;
            _this.setState({ isShowAll: true, cuttedEventIndex: Infinity, cuttedDate: '' }, function () { return handleShowMore && handleShowMore(); });
        };
        _this.agenda = function (_a) {
            var dateObject = _a.dateObject, localeToggle = _a.localeToggle, showNextMonth = _a.showNextMonth, month = _a.month;
            var _b = _this.state, isPastShown = _b.isPastShown, isShowAll = _b.isShowAll, cuttedDate = _b.cuttedDate, isReachedLastEvent = _b.isReachedLastEvent, isMounted = _b.isMounted;
            var _c = _this.props, dates = _c.dates, t = _c.t, isFixedSize = _c.isFixedSize, isMobile = _c.isMobile, isShowMoreButtonStyleSecondary = _c.isShowMoreButtonStyleSecondary;
            var _d = utils.getMonthDaysWithEvents({
                dateObject: dateObject,
                mutableDates: dates,
                isSorted: false,
            }), days = _d.datesToReturn, eventsAmount = _d.eventsAmount;
            var nextMonthButton = (React.createElement(Button, { onClick: showNextMonth, size: ButtonSize.medium, className: st(classes.TryNextMonthButton, {}) }, t('Google_Calendar_Try_Next_Month')));
            if (!eventsAmount) {
                return (React.createElement("div", { className: classes.NoEvents },
                    React.createElement("div", { style: { marginBottom: '40px' } },
                        React.createElement(Preloader, { className: "medium" })),
                    React.createElement(Text, { className: classes.MessageHeader, typography: TextTypography.runningText }, t('Google_Calendar_No_Events_This_Month')),
                    nextMonthButton));
            }
            var hasPastEvents = utils.hasPastEvents({ days: days });
            var hasTodayEvents = utils.hasTodayEvents({ days: days, dateObject: dateObject });
            var hasFutureEvents = utils.hasFutureEvents({ days: days });
            var isCurrentMonth = moment(dateObject).isSame(moment(), MomentEnum.monthString);
            var pastEventHeader = null;
            if (isCurrentMonth) {
                //@ts-ignore
                pastEventHeader = hasPastEvents ? (React.createElement(TextButton, { className: st(classes.ShowPastEvents, { isMobile: isMobile }), onClick: _this.showPastEvents }, t('Google_Calendar_Show_Past_Events'))) : (React.createElement(Text, { className: st(classes.MessageHeader, { isMobile: isMobile }), typography: TextTypography.runningText }, t('Google_Calendar_No_Past_Events')));
            }
            var jsxDays = utils.getMonthDays({
                days: days,
                dateObject: dateObject,
                daysInserter: _this.agendaDaysInserter({
                    localeToggle: localeToggle,
                    hasTodayEvents: hasTodayEvents,
                    hasFutureEvents: hasFutureEvents,
                }),
            });
            var isNoFutureAndTodayEvents = !hasTodayEvents && !hasFutureEvents;
            var noFutureAndTodayEvents = isCurrentMonth &&
                isNoFutureAndTodayEvents &&
                !isPastShown && (React.createElement("div", { className: classes.NoEvents },
                React.createElement(Text, { className: classes.NoMoreEventsThisMonth, typography: TextTypography.runningText }, t('Google_Calendar_No_More_Events_This_Month')),
                nextMonthButton));
            var showMoreButton = !isShowAll && cuttedDate && isFixedSize && !isReachedLastEvent ? (React.createElement(Button, { className: classes.ShowMore, onClick: _this.showMoreHandler, size: ButtonSize.medium, priority: isShowMoreButtonStyleSecondary
                    ? ButtonPriority.secondary
                    : ButtonPriority.basic }, t('Google_Calendar_Show_More'))) : null;
            return (React.createElement("div", { className: st(classes.Agenda, {
                    isPastShown: isPastShown,
                    isNoFutureAndTodayEvents: isNoFutureAndTodayEvents,
                    isCurrentMonth: isCurrentMonth,
                    hasPastEvents: hasPastEvents,
                    isMobile: isMobile,
                    isMounted: isMounted,
                }) },
                pastEventHeader,
                React.createElement("table", { "aria-labelledby": month, className: classes.AgendaTable },
                    React.createElement("tbody", null, jsxDays)),
                noFutureAndTodayEvents,
                showMoreButton));
        };
        _this.resizeHandler = function () {
            var _a = _this.state, prevHeight = _a.windowHeight, cuttedEventIndex = _a.cuttedEventIndex, cuttedDate = _a.cuttedDate, isReachedLastEvent = _a.isReachedLastEvent;
            var nextHeight = window.innerHeight;
            if (prevHeight > nextHeight) {
                _this.setState({ isShrinking: true, windowHeight: nextHeight }, function () {
                    return _this.eventCutHandler(cuttedEventIndex - 1, _this.eventRef, cuttedDate, true);
                });
            }
            else if (prevHeight < nextHeight) {
                _this.setState({ isShrinking: false, windowHeight: nextHeight }, function () {
                    return !isReachedLastEvent &&
                        _this.eventAddtionHandler(cuttedEventIndex + 1, _this.eventRef, cuttedDate);
                });
            }
        };
        return _this;
    }
    AgendaCalendar.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.isFixedSize !== this.props.isFixedSize) {
            this.initState();
        }
    };
    AgendaCalendar.prototype.componentDidMount = function () {
        this.setState({ isMounted: true });
        // const { dates, recurrenceArr } = this.props;
        // for (const key in dates) {
        //   const arr = dates[key];
        //   arr.map((event) => {
        //     if (event.recurringEventId) {
        //       const res = recurrenceArr.find(
        //         (el) => el.recurrenceId === event.recurringEventId,
        //       );
        //       typeof res !== 'undefined' && (event.recurrence = res.recurrence);
        //     }
        //   });
        // }
        window.addEventListener('resize', this.resizeHandler);
    };
    AgendaCalendar.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.resizeHandler);
    };
    AgendaCalendar.prototype.render = function () {
        var _a = this.props, isNextDisabled = _a.isNextDisabled, isPrevDisabled = _a.isPrevDisabled, locale = _a.locale, isTodayButtonStyleSecondary = _a.isTodayButtonStyleSecondary, isTimezoneShown = _a.isTimezoneShown, error = _a.error, handleTimezoneChange = _a.handleTimezoneChange, timezone = _a.timezone, isMobile = _a.isMobile, calendarRef = _a.calendarRef, openPopup = _a.openPopup, action = _a.action, isLiveSite = _a.isLiveSite, experiments = _a.experiments, wixStyles = _a.wixStyles, isEditorX = _a.isEditorX;
        return (React.createElement(CalendarPropsContext.Provider
        // @ts-ignore
        , { 
            // @ts-ignore
            value: __assign({}, getCalendarPropsData(this.props)) },
            React.createElement(WixStylesContext.Provider, { value: __assign({}, getWixStylesContextData(wixStyles)) },
                React.createElement(Calendar, { isEditorX: isEditorX, handleMonthChange: this._handleMonthChange, locale: locale, isTodayButtonStyleSecondary: isTodayButtonStyleSecondary, isTimezoneShown: isTimezoneShown, error: error, handleTimezoneChange: handleTimezoneChange, timezone: timezone, isMobile: isMobile, calendarRef: calendarRef, action: action, isNextDisabled: isNextDisabled, isPrevDisabled: isPrevDisabled, openPopup: openPopup, isLiveSite: isLiveSite, onTodayClick: this._onTodayClick }, this.agenda))));
    };
    AgendaCalendar.defaultProps = {
        locale: 'en',
        dates: {},
        isTodayButtonStyleSecondary: true,
        isTimezoneShown: true,
        isTimeShown: true,
        error: '',
        isLiveSite: false,
        handleTimezoneChange: null,
        alignment: CalendarCellAlignment.left,
        timezone: '',
        timeFormat: TimeFormatsEnum.tweleveHours,
        isFixedSize: false,
        onEventExpanded: null,
        weekStarter: WeekStarters.Monday,
        // recurrenceArr: [],
    };
    return AgendaCalendar;
}(React.Component));
//@ts-ignore
export default withTranslation()(AgendaCalendar);
//# sourceMappingURL=AgendaCalendar.js.map